module.exports = __webpack_public_path__ + "img/everything_bagel_spice.c7218dca.jpg";